import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { BankListResponse } from '../models/models'

export class GetBankListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction',
      requesterInfo,
    })
  }

  public async getParamBanks(): Promise<BankListResponse[]> {
    return await this.getAsync<BankListResponse[]>('bankListParam')
  }

  public async getParatikaBanks(): Promise<BankListResponse[]> {
    return await this.getAsync<BankListResponse[]>('bankListParatika')
  }

  public async getAkOdeBanks(): Promise<BankListResponse[]> {
    return await this.getAsync<BankListResponse[]>('bankListAkOde')
  }
}